export function alertSoloAllenatore () {
    alert('solo allenatore');
}
